import {
  ClientDTO,
  IOurEntity,
  CandidateDTO,
  IClientCurrencySettings,
  ILocation,
  ClientContactDTO,
  FeeArrangementDTO,
  PlacementOriginDTO,
} from 'wisestep-api';
import IBusinessUnit from 'wisestep-website/src/features/ourEntity/types/IBusinessUnit';

export interface ClosureDetailsDTO {
  id: string;
  ourEntity: IOurEntity;
  ourEntityName: string;
  client: ClientDTO;
  clientName: string;
  candidate: CandidateDTO;
  candidateLocation: ILocation;
  candidateContact: string;
  positionId: string;
  positionTitle: string;
  positionLocation: ILocation[];
  offerDate: Date | null;
  joiningDate: Date | null;
  currency: IClientCurrencySettings;
  currencyId: string;
  period: string;
  feeArrangement: FeeArrangementDTO;
  commissionValue: number;
  employmentGuaranteeDays: number;
  employmentGuaranteeEndDate: Date | null;
  contractGuaranteeEndDate: Date | null;
  accountManager: string;
  teamLead: string;
  recruiterOne: string;
  recruiterTwo: string;
  deliveryManager: string;
  deliveryLead: string;
  clientRecruiterOne: ClientContactDTO;
  clientRecruiterTwo: ClientContactDTO;
  clientRecruiterIdOne: string;
  comments: string;
  workspaceId: string;
  submissionId: string;
  placementStatusId?: string;
  placementStatusReason?: string;
  businessUnit: IBusinessUnit | null;
  placementOrigin?: PlacementOriginDTO;
  wisestepCandidate: boolean;
  arrangementType: string;
  feeType?: string;
  feeArrangementAmount: number;
  customFields?: any;
  description: string;
  endDate?: Date | null;
  buyRateAmount?: number | null;
  buyRateCurrency?: IClientCurrencySettings | null;
  buyRateFrequency?: string | null;
  buyRateDescription?: string | null;
  sellRateAmount?: number | null;
  sellRateCurrency?: IClientCurrencySettings | null;
  sellRateFrequency?: string | null;
  sellRateDescription?: string | null;
  overtimeApplicable?: boolean | null;
  overTimeBuyRateAmount?: number | null;
  overTimeBuyRateCurrency?: IClientCurrencySettings | null;
  overTimeBuyRateFrequency?: string | null;
  overTimeSellRateAmount?: number | null;
  overTimeSellRateCurrency?: IClientCurrencySettings | null;
  overTimeSellRateFrequency?: string | null;
  noticePeriod?: number | null;
  renewalPeriod?: string | null;
  team: string;
  businessUnitId?: string;
  businessUnitName?: string;
}

export class ClosureDetailsDTO {
  constructor(closureDetailsDTO: ClosureDetailsDTO) {
    Object.assign(this, closureDetailsDTO);
    this.feeArrangement = new FeeArrangementDTO(closureDetailsDTO.feeArrangement);
  }
}
